import { request } from '../core';
import { Method } from '../core/util';
import { CommonResponse } from '@/utils/type';

/**
 * 创建事故入参类型
 */
export interface ManualCreateAccidentParams {
  technicalSupportDescription: string;
  responsible: string;
  technicalSupportAccidentLevel: string;
  vehicleName: string;
  accidentAddress: string;
  // 格式: YYYY-MM-DD HH:mm:ss
  accidentTime: string;
  // 上传附件（通常包含 type 和 fileKey），组件中也可能包含 uid 等字段
  technicalSupportAttmentList?: Array<{
    type?: string;
    fileKey?: string;
    uid?: string;
  }>;
  // 工单编号，用于事故单和工单关联（只有从工单抽屉提报的事故单才需要此字段，即才需要建立关联关系）
  issueNumber?: string;
}

/**
 * 事故管理接口类
 * @class AccidentApi
 */
class AccidentApi {
  /**
   * 人工创建事故
   * @param {ManualCreateAccidentParams} params
   * @return {*}  {Promise<CommonResponse<null>>}
   * @memberof AccidentApi
   */
  public manualCreateAccident(
    params: ManualCreateAccidentParams
  ): Promise<CommonResponse<null>> {
    const requestParam: RequestOptions = {
      path: '/monitor/web/accident/manual_create_accident',
      method: Method.POST,
      body: params,
    };
    return request(requestParam);
  }
}

export const accidentApi = new AccidentApi();
